
import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

interface MapComponentProps {
  address: string;
  latitude?: number;
  longitude?: number;
}

const MapComponent: React.FC<MapComponentProps> = ({ address, latitude, longitude }) => {
  const mapContainer = useRef<HTMLDivElement>(null);
  const map = useRef<mapboxgl.Map | null>(null);

  // Use provided coordinates or fallback to Harpenden
  const mapLat = latitude || 51.8142;
  const mapLng = longitude || -0.3503;

  useEffect(() => {
    if (!mapContainer.current) return;

    // Initialize map with your token
    mapboxgl.accessToken = 'pk.eyJ1IjoiYW5keW5yeCIsImEiOiJjbWIzdjZudTQxdGZrMmlwN2VkZmllNXlvIn0.P5KA_2hM29cRAdVZjBjGzw';
    
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [mapLng, mapLat],
      zoom: 15,
    });

    // Add marker for the location
    new mapboxgl.Marker()
      .setLngLat([mapLng, mapLat])
      .addTo(map.current);

    // Add navigation controls
    map.current.addControl(new mapboxgl.NavigationControl(), 'top-right');

    // Cleanup
    return () => {
      map.current?.remove();
    };
  }, [mapLat, mapLng]);

  return (
    <div className="relative w-full h-full">
      <div ref={mapContainer} className="absolute inset-0 rounded-lg" />
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent to-background/10 rounded-lg" />
    </div>
  );
};

export default MapComponent;
